import { Grid, colors as colorsMUI } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { useState, useEffect } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut as Pie } from "react-chartjs-2";
import HelpIcon from "@mui/icons-material/Help";
import ReactTooltip from "react-tooltip";

ChartJS.register(ArcElement, Tooltip, Legend);

const classes = {
  lblGraph: {
    backgroundColor: "#F5F5F5",
    color: "#155BCB",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    borderRadius: 3,
    height: "35px",
    display: "flex",
    alignItems: "center",
    padding: 10,
  },
  graph: {
    border: "1px solid #D1CCCC",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    height: "300px",
  },

  gridLabel: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 5,
  },
  helpText: {
    marginTop: -4,
    cursor: "pointer",
  },
};

const stepStatus = ["Abertura", "Homologação", "Execução", "Conclusão"];

// Mapeamento do campo status para a etapa correspondente
function getStepStatusFromStatus(status) {
  const statusMapping = {
    // Abertura
    "Novo": "Abertura",
    // Homologação
    "Em análise": "Homologação",
    "Aguardando Informação": "Homologação",
    "Autorizado/Aprovado": "Homologação",
    "Solução de longo prazo / Sugestão de projeto": "Homologação",
    // Execução
    "Em execução": "Execução",
    "Encaminhado para o executor": "Execução",
    "Notificado para providências": "Execução",
    // Conclusão
    "Resolvido": "Conclusão",
    "Indeferido": "Conclusão",
    "Respondido": "Conclusão",
    "Detecção incorreta": "Conclusão"
  };
  return statusMapping[status] || null;
}

function getQuantOccurrencesByStatus(occurrences) {
  //Cria um objeto com os nomes dos estados
  let quantOccurrencesByName = {};
  stepStatus.forEach((statusName) => (quantOccurrencesByName[statusName] = 0));

  occurrences.forEach((occurrence) => {
    const step = getStepStatusFromStatus(occurrence.status);
    if (step) {
      quantOccurrencesByName[step]++;
    }
  });

  return quantOccurrencesByName;
}

function getPercentagesByStatusStep(quantOccurrencesByStatus, length) {
  let quantOccurrencesByName = {};
  stepStatus.forEach((statusName) => (quantOccurrencesByName[statusName] = 0));

  const quantTotalOccurences = length;

  Object.keys(quantOccurrencesByStatus).forEach((item) => {
    quantOccurrencesByName[item] =
      (quantOccurrencesByStatus[item] / quantTotalOccurences) * 100;
  });

  return quantOccurrencesByName;
}

const OccurrenceByStatus = ({ occurrences }) => {
  const [occurrenceAmounts, setOccurrenceAmounts] = useState([]);
  const [occurrencePercentages, setOccurrencePercentages] = useState([]);

  useEffect(() => {
    updateGraph();
  }, [occurrences, stepStatus]); // eslint-disable-line react-hooks/exhaustive-deps

  function updateGraph() {
    const colors = ["#f24822", "#5ea1cf", "#a7db64", "#796d33"];

    let quantOccurrencesByStatus = getQuantOccurrencesByStatus(occurrences);
    let percentagesByStatus = getPercentagesByStatusStep(
      quantOccurrencesByStatus,
      occurrences.length
    );

    if (occurrences.length === 0) {
      //Se não houver ocorrências no perído escolhido
      setOccurrenceAmounts([]);
      setOccurrencePercentages({});
    } else {
      let newAmounts = [];

      stepStatus.forEach((statusName, index) => {
        newAmounts.push({
          title: statusName,
          value: percentagesByStatus[statusName].toFixed(1),
          icon: ErrorIcon,
          color: colors[index],
        });
      });
      setOccurrenceAmounts(newAmounts);

      setOccurrencePercentages({
        datasets: [
          {
            data: Object.values(percentagesByStatus), //Objeto para vetor
            backgroundColor: colors,
            borderWidth: 3,
            borderColor: colorsMUI.common.white,
            hoverBorderColor: colorsMUI.common.white,
          },
        ],
        labels: stepStatus,
      });
    }
  }

  const options = {
    type: "doughnut",
    animation: true,
    layout: { padding: 0 },
    plugins: {
      legend: {
        display: true,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  return (
    <div id="total-ocurrencies-dashboard" style={{ width: "100%" }}>
      <Grid item xs={12} sm={12} md={12} lg={12} style={classes.lblGraph}>
        <div style={classes.gridLabel}>
          <div>Total de Ocorrências:</div>

          <div style={classes.helpText}>
            <ReactTooltip id="proportion-info" className="popup" />
            <HelpIcon
              style={{ color: "#a1a5ab" }}
              fontSize="small"
              data-for="proportion-info"
              data-place="bottom"
              data-tip="Um gráfico que apresenta a relação entre as etapas dos status das ocorrências."
            />
          </div>
        </div>
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} style={classes.graph}>
        {Object.keys(occurrenceAmounts).length === 0 ? (
          <span
            style={{
              fontSize: "16px",
              margin: "30px",
              textAlign: "center",
              display: "block",
            }}
          >
            Não há ocorrências
          </span>
        ) : (
          <Pie data={occurrencePercentages} options={options} />
        )}
      </Grid>
    </div>
  );
};

export default OccurrenceByStatus;
